import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ClubProvider } from "@/contexts/ClubContext";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import CalendarPage from "@/pages/CalendarPage";
import NewsPage from "@/pages/NewsPage";
import GalleryPage from "@/pages/GalleryPage";
import ClubPage from "@/pages/ClubPage";
import PricelistPage from "@/pages/PricelistPage";
import ShopPage from "@/pages/ShopPage";
import LeagueRankingsPage from "@/pages/LeagueRankingsPage";
import ReservationPage from "@/pages/ReservationPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import SecretLoginPage from "@/pages/SecretLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import QRLandingPage from "@/pages/QRLandingPage";
import QRCodesPage from "@/pages/QRCodesPage";
import MemberRegisterPage from "@/pages/MemberRegisterPage";
import MemberLoginPage from "@/pages/MemberLoginPage";
import MemberPortalPage from "@/pages/MemberPortalPage";
import EventDetailPage from "@/pages/EventDetailPage";
import SponsorsPage from "@/pages/SponsorsPage";
import DownloadsPage from "@/pages/DownloadsPage";
import PasswordResetPage from "@/pages/PasswordResetPage";
import CountdownBar from "@/components/CountdownBar";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <ClubProvider>
        <ScrollToTop />
        <Toaster richColors position="top-right" />
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="/kalender" element={<CalendarPage />} />
            <Route path="/neuigkeiten" element={<NewsPage />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/club/:clubId" element={<ClubPage />} />
            <Route path="/getraenkekarte" element={<PricelistPage />} />
            <Route path="/preisliste" element={<PricelistPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/ligaplatzierung" element={<LeagueRankingsPage />} />
            <Route path="/reservierung" element={<ReservationPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/qr/:type/:number" element={<QRLandingPage />} />
            <Route path="/mitglied-registrieren" element={<MemberRegisterPage />} />
            <Route path="/mitglied-login" element={<MemberLoginPage />} />
            <Route path="/passwort-reset" element={<PasswordResetPage />} />
            <Route path="/mein-bereich" element={<MemberPortalPage />} />
            <Route path="/event/:id" element={<EventDetailPage />} />
            <Route path="/downloads" element={<DownloadsPage />} />
          </Route>
          <Route path="/admin-login" element={<SecretLoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/qr-codes" element={<QRCodesPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
        </Routes>
        <CountdownBar />
      </ClubProvider>
    </BrowserRouter>
  );
}

export default App;
